module.exports = __webpack_public_path__ + "ed81a8d6a2f4b145d13aa3063f1d6798.jpg";